import { onMounted, onBeforeUnmount } from "vue"
import { useRoute } from "vue-router"

export default function onAwayChangeDocumentTitle(awayTitle = "😢 Come Back!") {
  const activeRoute = useRoute()
  const DEFAULT_TITLE = "Career Test - JobTest.org"

  function handleVisibilityChange() {
    if (document.hidden) document.title = awayTitle
    else document.title = activeRoute.meta?.title ?? DEFAULT_TITLE
  }

  onMounted(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange)
  })

  onBeforeUnmount(() => {
    document.removeEventListener("visibilitychange", handleVisibilityChange)
  })
}
